import { useQuery, useMutation } from 'react-query';

import { getDataRanking, getCurrentTeamF11 } from '@/services/team11';

export const useGetCurrentTeamF11 = (enabled = true) => {
  return useQuery(
    'useGetCurrentTeamF11',
    async () => await getCurrentTeamF11(),
    {
      refetchOnWindowFocus: false,
      keepPreviousData: false,
      enabled,
    }
  );
};

export const usePostDataRanking = () => {
  return useMutation(async (date: string) => await getDataRanking(date));
};
